import { useState, useMemo } from 'react';

const EquipeForm = ({ cartes, eleves, onSave, onCancel, equipe }) => {
  const [nom, setNom] = useState(equipe?.nom || '');
  const [carteId, setCarteId] = useState(equipe?.carte ? String(equipe.carte) : '');
  const [selectedEleves, setSelectedEleves] = useState(equipe?.eleves || []);

  const selectedSet = useMemo(() => new Set(selectedEleves), [selectedEleves]);

  const handleToggleEleve = (eleveId) => {
    if (selectedSet.has(eleveId)) {
      setSelectedEleves((prev) => prev.filter((id) => id !== eleveId));
    } else {
      setSelectedEleves((prev) => [...prev, eleveId]);
    }
  };

  const handleSave = () => {
    onSave({
      nom,
      carte: Number(carteId),
      eleves: selectedEleves,
    });
  };

  const isValid = nom.trim() && carteId && selectedEleves.length > 0;

  return (
    <div className="space-y-4 p-4 rounded-xl border border-gray-200 bg-gray-50">
      {/* Nom */}
      <div>
        <label htmlFor="equipe-nom" className="block text-sm font-medium text-gray-600 mb-1">
          Nom de l'équipe
        </label>
        <input
          id="equipe-nom"
          type="text"
          value={nom}
          onChange={(e) => setNom(e.target.value)}
          placeholder="Ex : Equipe Alpha"
          className="w-full px-3 py-2 rounded-lg bg-white border border-gray-200 text-gray-700 text-sm placeholder-gray-400 focus:ring-2 focus:ring-blue-300/50 focus:border-blue-300 focus:outline-none"
        />
      </div>

      {/* Carte */}
      <div>
        <label htmlFor="equipe-carte" className="block text-sm font-medium text-gray-600 mb-1">
          Carte ArUco
        </label>
        <select
          id="equipe-carte"
          value={carteId}
          onChange={(e) => setCarteId(e.target.value)}
          className="px-3 py-2 rounded-lg bg-white border border-gray-200 text-gray-700 text-sm focus:ring-2 focus:ring-blue-300/50 focus:border-blue-300 focus:outline-none"
        >
          <option value="">-- Choisir --</option>
          {cartes.map((c) => (
            <option key={c.id} value={c.id}>
              Carte #{c.code_aruco}
            </option>
          ))}
        </select>
      </div>

      {/* Élèves */}
      <div>
        <p className="text-sm font-medium text-gray-600 mb-2">Élèves</p>
        <div className="space-y-1 max-h-48 overflow-y-auto">
          {eleves.map((e) => (
            <label key={e.id} className="flex items-center gap-3 p-2 rounded-lg hover:bg-gray-100 cursor-pointer transition">
              <input
                type="checkbox"
                checked={selectedSet.has(e.id)}
                onChange={() => handleToggleEleve(e.id)}
                className="rounded border-gray-300 bg-white text-indigo-500 focus:ring-indigo-500"
              />
              <span className="text-sm text-gray-700">
                {e.nom} {e.prenom}
                {e.classe_nom && (
                  <span className="ml-1.5 text-[10px] text-gray-400">({e.classe_nom})</span>
                )}
              </span>
            </label>
          ))}
        </div>
      </div>

      {/* Actions */}
      <div className="flex items-center gap-3 pt-2">
        <button
          onClick={handleSave}
          disabled={!isValid}
          aria-label="Enregistrer"
          className="px-4 py-2 rounded-xl bg-emerald-500 hover:bg-emerald-600 text-white font-semibold text-sm transition disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Enregistrer
        </button>
        <button
          onClick={onCancel}
          aria-label="Annuler"
          className="px-4 py-2 rounded-xl bg-orange-500 hover:bg-orange-600 text-white font-semibold text-sm transition"
        >
          Annuler
        </button>
      </div>
    </div>
  );
};

export default EquipeForm;
